import Events from './Events';
import { Wrapper } from '../Style';

function Announcement() {
  return (
    <Wrapper>
      <Events />
    </Wrapper>
  );
}

export default Announcement;
